module.exports = __webpack_public_path__ + "img/icon_mail_white.127e262.svg";